import Vue from 'vue'
import Router from 'vue-router'
import components from './components'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/auth_sandbox',
      component: components.auth_sandbox,
    },
    {
      path: '/sandbox',
      component: components.sandbox,
    },
    {
      path: '/audio',
      component: components.audio
    },
    {
      path: '/style_guide',
      component: components.style_guide.main,
      children: [
        {
          path: 'fonts',
          component: components.style_guide.fonts
        },
        {
          path: 'atoms',
          component: components.style_guide.atoms
        },
        {
          path: 'molecules',
          component: components.style_guide.molecules
        },
        {
          path: 'organisms',
          component: components.style_guide.organisms
        },
        {
          path: '',
          component: components.style_guide.fonts
        },
        {
          path: '*',
          component: components.style_guide.fonts
        }
      ]
    },
    {
      path: '*',
      component: components.main
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js